import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { TruckIcon, PackageIcon, TickIcon } from "@/components/icons/assets";

const glsFeatures = [
  "Rims without tires",
  "Small wheel packages",
  "Home delivery",
  "Fast and reliable service",
];

const bringFeatures = [
  "Complete wheel sets",
  "Wheels with tires",
  "Pallet-based delivery",
  "Secure handling for heavy items",
];

export default function ShippingMethodsSection() {
  return (
    <section id="shipping-content" className="py-10 sm:py-14 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8 lg:px-20 bg-white">
      {/* Header */}
      <div className="text-center mb-8 sm:mb-12 md:mb-16">
        <Badge variant="outline" className="font-plus-jakarta text-xs sm:text-sm font-medium text-neutral-500 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 mb-4 sm:mb-6">
          Our Shipping Methods
        </Badge>
        <h2 className="font-plus-jakarta text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-900 mb-4 sm:mb-6">
          THE RIGHT DELIVERY METHOD<br className="hidden sm:block" /> FOR EVERY ORDER
        </h2>
        <p className="font-plus-jakarta text-xs sm:text-sm md:text-base text-neutral-300 max-w-2xl mx-auto">
          We automatically select the best shipping method based on your order type, ensuring safe handling and reliable delivery without any extra steps
        </p>
      </div>

      {/* Shipping Methods Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        {/* GLS Delivery Card */}
        <Card className="bg-background-50 border-none rounded-xl sm:rounded-2xl shadow-none">
          <CardContent className="p-4 sm:p-6 md:p-8">
            {/* Icon */}
            <div className="flex justify-end mb-4">
              <PackageIcon className="" />
            </div>

            {/* Title & Subtitle */}
            <h3 className="font-plus-jakarta text-lg sm:text-xl md:text-2xl font-bold text-neutral-900 mb-2">
              GLS DELIVERY
            </h3>
            <p className="font-plus-jakarta text-sm sm:text-ba  se font-medium text-neutral-500 mb-4">
              For Small & Medium Shipments
            </p>
            <p className="font-plus-jakarta text-xs sm:text-sm text-neutral-300 mb-6">
              GLS is used for lighter orders that can be delivered quickly and safely.
            </p>

            {/* Features */}
            <Card className="bg-white border-none rounded-xl shadow-none mb-6">
              <CardContent className="p-4 sm:p-6">
                <ul className="space-y-3 sm:space-y-4">
                  {glsFeatures.map((feature, index) => (
                    <li key={index} className="flex items-center gap-3">
                      <div className="">
                        <TickIcon />
                      </div>
                      <span className="font-plus-jakarta text-sm sm:text-base text-neutral-800">{feature}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>

            {/* Footer Note */}
            <p className="font-plus-jakarta text-xs sm:text-sm text-neutral-900 italic">
              Shipping method is selected automatically.
            </p>
          </CardContent>
        </Card>

        {/* Bring Freight Delivery Card */}
        <Card className="bg-background-50 border-none rounded-xl sm:rounded-2xl shadow-none">
          <CardContent className="p-4 sm:p-6 md:p-8">
            {/* Icon */}
            <div className="flex justify-end mb-4">
              <TruckIcon className="" />
            </div>

            {/* Title & Subtitle */}
            <h3 className="font-plus-jakarta text-lg sm:text-xl md:text-2xl font-bold text-neutral-900 mb-2">
              BRING FREIGHT DELIVERY
            </h3>
            <p className="font-plus-jakarta text-sm sm:text-base font-medium text-neutral-500 mb-4">
              For Large & Heavy Shipments
            </p>
            <p className="font-plus-jakarta text-xs sm:text-sm text-neutral-300 mb-6">
              Bring is used for larger orders that require pallet transport and extra care.
            </p>

            {/* Features */}
            <Card className="bg-white border-none rounded-xl shadow-none mb-6">
              <CardContent className="p-4 sm:p-6">
                <ul className="space-y-3 sm:space-y-4">
                  {bringFeatures.map((feature, index) => (
                    <li key={index} className="flex items-center gap-3">
                      <div className="">
                        <TickIcon />
                      </div>
                      <span className="font-plus-jakarta text-sm sm:text-base text-neutral-800">{feature}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>

            {/* Footer Note */}
            <p className="font-plus-jakarta text-xs sm:text-sm text-neutral-900 italic">
              Shipping method is selected automatically.
            </p>
          </CardContent>
        </Card>
      </div>
    </section>
  );
}
